export default "__VITE_ASSET__e7111911__"